module.exports = function (settingsService) {
    return {
        restrict: 'E',
        scope: {
            card: '='
        },
        require: '?^wowCard',
        link(scope) {
            scope.clickTracker = function () {
                fetch(this.card.ClickTracker);
            };
            settingsService.getSettingValue('SponsoredAd', 'EnableCriteoSponsoredAdsWeb').then(function (setting) {
                scope.enableCriteoSponsoredAds = setting || false;
            });
            scope.viewTrackerArray = [];
            scope.scrollTracking = function() {
                if(scope.enableCriteoSponsoredAds && this.card.ViewTracker && scope.viewTrackerArray.indexOf(this.card.ViewTracker) === -1){
                    scope.viewTrackerArray.push(this.card.viewTrackerArray);
                    if(navigator.sendBeacon){
                        navigator.sendBeacon(this.card.ViewTracker);
                    }else{
                        fetch(this.card.ViewTracker);
                    }
                }
            };
        },
        template: require('./feature-card-template.html').trim()
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/feature-card/feature-card-directive.js
 **/